import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ZoomAction } from '@textbook-api-client';
import { TextbookActionBase } from '../@base/textbook-action-base.model';
import { GroupInfo } from '../../models';

@Component({
  selector: 'txtb-zoom',
  templateUrl: './zoom.component.html',
  styleUrls: ['./zoom.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ZoomComponent extends TextbookActionBase<ZoomAction> {
  @Input() groupInfo!: GroupInfo;

  constructor() {
   super();
  }
}
